import React from "react";

import background from "../assets/images/landing.png";
import avatar     from "../assets/images/geneen.png";
import logos      from "../assets/partner-logos";
import ReserveButton from "./ButtonReserve";

export default function Landing() {
  return (
    <section
      className="relative flex flex-col items-center w-full text-center min-h-[700px] lg:min-h-[900px] px-4 sm:px-6"
      style={{
        backgroundImage   : `url(${background})`,
        backgroundSize    : "cover",
        backgroundPosition: "center",
      }}
    >
      <div className="absolute inset-0" />
      <div className="relative flex flex-col items-center gap-5 mt-10 sm:mt-16 md:pb-16 lg:pb-0">
        <div>
          <h1 className="text-[#165263] font-medium font-roboto leading-tight text-3xl sm:text-4xl md:text-5xl lg:text-6xl max-w-5xl">
            Ending Self-Rejection
            <br />
            <span className="text-2xl sm:text-3xl md:text-4xl lg:text-5xl">
              and being at ease with food, body and weight
            </span>
          </h1>
        </div>
        <p className="text-black italic font-medium font-roboto text-base sm:text-lg md:text-xl max-w-3xl">
          Join New York Times bestselling author and Oprah-featured speaker&nbsp;Geneen Roth for a powerful, virtual experience.
        </p>
        <div className="grid items-start gap-8 w-full max-w-5xl grid-cols-1 lg:grid-cols-[180px_1fr]">
          <div className="flex justify-center lg:justify-end">
            <img
              src={avatar}
              alt="Geneen Roth"
              className="rounded-full object-cover object-top shadow-xl ring-4 ring-[#9AEEDA] ring-offset-4 ring-offset-white/30 w-32 h-32 sm:w-40 sm:h-40 lg:w-44 lg:h-44"
            />
          </div>
          <div className="flex flex-col items-center gap-5">
            <ul className="list-disc list-inside text-left text-black italic font-roboto text-base sm:text-lg marker:text-black space-y-4">
              <li>Heal your relationship with food and uncover what it reveals about your beliefs.</li>
              <li>Break free from the endless cycle of diets and self-criticism.</li>
              <li>Create lasting change by channeling your energy into what truly matters in your life.</li>
            </ul>

            <div className="flex flex-col items-center gap-4">
              <p className="font-roboto text-lg sm:text-xl font-semibold text-black text-center">
                On Retreat with Geneen - Live Online
                <br />
                <span className="font-normal text-base sm:text-lg">January 21-24, 2027</span>
              </p>
              <ReserveButton />
              <span className="text-red-600 font-bold text-xs sm:text-sm bg-white/50 backdrop-blur-sm px-6 py-3 rounded-2xl">
                SAVE $100 when you register early
              </span>
            </div>
          </div>
        </div>
      </div>
      <div className="w-full bg-white/60 py-5 px-6 mt-10 md:mt-auto">
        <p className="font-roboto text-xs sm:text-sm text-black text-center max-w-5xl mx-auto">
          As a New York Times bestselling author and featured on Oprah, NPR, and Goop, Geneen Roth’s work has transformed countless lives through her unique insights on food, body, and self-worth.
        </p>
        {logos?.length > 0 && (
          <div className="flex flex-wrap justify-center gap-4 mt-4">
            {logos.map((src, i) => (
              <img key={i} src={src} alt="Partner logo" className="h-8 sm:h-10 object-contain" />
            ))}
          </div>
        )}
      </div>
    </section>
  );
}
